module.exports = __webpack_public_path__ + "static/media/Harvest soffa 2,5-sits öppet avslut tyg Brego färg 3593 light brown 9.7ce17638.jpg";